import { apiHelpers } from './api';
import { Department, ApiResponse, DepartmentFormData } from '../types/models';

export class DepartmentService {
  // Получить отдел по ID
  static async getById(id: number): Promise<ApiResponse<Department>> {
    return apiHelpers.get<Department>(`/Department/Get?id=${id}`);
  }

  // Получить все отделы
  static async getAll(): Promise<ApiResponse<Department[]>> {
    return apiHelpers.get<Department[]>(`/Department/GetAll`);
  }

  // Получить отделы по компании
  static async getByCompany(companyId: number): Promise<ApiResponse<Department[]>> {
    return apiHelpers.get<Department[]>(`/Department/GetByCompany?companyId=${companyId}`);
  }

  // Создать новый отдел
  static async create(data: DepartmentFormData): Promise<ApiResponse<Department>> {
    return apiHelpers.post<Department>('/Department/Create', data);
  }

  // Обновить отдел
  static async update(id: number, data: DepartmentFormData & { id: number }): Promise<ApiResponse<void>> {
    return apiHelpers.put<void>(`/Department/Update/${id}`, data);
  }

  // Удалить отдел
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/Department/Delete/${id}`);
  }
}

